import { render } from "./500.vue?vue&type=template&id=4de1ebb2"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"

import "./500.vue?vue&type=style&index=0&id=4de1ebb2&lang=scss"
script.render = render

export default script